import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ReactTooltip from 'react-tooltip';
import BoonButton from '../button/boon-button';

interface ForgotPasswordProps {
    onSubmit: (username: string) => Promise<void>;
    onClickSubmit: (event) => void;
}

interface FormData {
    email: string;
}

const ForgotPasswordForm: React.FC<ForgotPasswordProps> = props => {
    const { register, handleSubmit, errors } = useForm<FormData>();
    const { t } = useTranslation();
    const [disabled, setDisabled] = useState(false);

    const rebuildTooltip = () => {
        setTimeout(() => {
            ReactTooltip.rebuild();
        }, 10);
    };

    const onSubmit = handleSubmit(async ({ email }: FormData) => {
        setDisabled(true);
        await props.onSubmit(email);
        setDisabled(false);
    });

    return (
        <form
            name="forgot-password-form"
            className="pt-5 px-6 pb-0 rounded text-charcoal font-gr-book"
            onSubmit={onSubmit}
            noValidate
        >
            <ReactTooltip
                id="validation"
                className="w-1/2 xsm:w-4/12 md:w-3/12 lg:w-2/12 xxl:w-1/12 text-xs"
                effect="solid"
                event="focusin"
                eventOff="blur"
                multiline={true}
                place="left"
                delayShow={250}
            />
            <h1 className="text-xl mt-4 mb-4 text-center text-charcoal">{t('base:forgot-password-title')}</h1>
            <div className="EmailInput mb-6 relative">
                <label htmlFor="email" className="label base-label text-center px-4">
                    {t('base:cant-login-label')}
                </label>
                <input
                    className="relative input base-input mt-6"
                    id="email"
                    type="email"
                    name="email"
                    autoFocus
                    onFocus={rebuildTooltip}
                    onChange={rebuildTooltip}
                    ref={register({
                        required: {
                            value: true,
                            message: t('validation:required'),
                        },
                        pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                            message: t('validation:invalid-email'),
                        },
                    })}
                />
                {errors.email && (
                    <span className="base-error-icon top-32">
                        <FontAwesomeIcon
                            className="fa-lg"
                            icon={faExclamationCircle}
                            data-tip={errors.email.message}
                            data-for="validation"
                        />
                    </span>
                )}
            </div>
            <div className="text-center">
                <BoonButton
                    style="dark"
                    height="h-10"
                    width="w-28"
                    type="submit"
                    onClick={onSubmit}
                    disabled={disabled}
                    font="text-white uppercase font-bold text-xs"
                    addtlContainerClasses="SubmitButton"
                >
                    {t('base:forgot-password-submit')}
                </BoonButton>
            </div>
        </form>
    );
};

export default ForgotPasswordForm;
